import React, {createContext, useContext} from 'react';

import {EditorBlock as CoreEditorBlock} from './core';
import {useDocument} from './EditorContext';
import {useManagerContext} from "../../../../sections/emails/ManagerContext";
import {EditorDisabled} from "./EditorDisabled";
import Loading from "../../../../sections/generic/Loading";


const EditorBlockContext = createContext(null);
export const useCurrentBlockId = () => useContext(EditorBlockContext);

/**
 *
 * @param id - Block id
 * @returns EditorBlock component that loads data from the EditorDocumentContext
 */
export default function EditorBlock({id}) {
    const {email, isLoading} = useManagerContext();

    const document = useDocument();
    const block = document[id];


    if (!block) {
        throw new Error('Could not find block');
    }
    return (
        <>
            {isLoading && <Loading styles={{height: 'calc(100vh - 49px)'}} />}
            {
                !isLoading && email?.content?.html?.length > 0
                    ? <EditorDisabled/>
                    : <EditorBlockContext.Provider value={id}>
                        <CoreEditorBlock {...block} />
                    </EditorBlockContext.Provider>
            }
        </>
    );
}
